import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import messages from 'containers/LoginPage/messages';
import { isDrpp, isNumAdhesion } from 'utils/amcUtils';

export default (props: any) =>
  Yup.object().shape({
    identifiant: Yup.string()
      .notRequired()
      .when('hasAmc', {
        is: (hasAmc) => !hasAmc,
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().notRequired(),
      }),
    password: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    organization: Yup.object()
      .nullable()
      .when('hasAmc', {
        is: (hasAmc) => hasAmc,
        then: Yup.object().required(translate(messages.requiredField, props)),
        otherwise: Yup.object().nullable(),
      }),
    drpp: Yup.string()
      .notRequired()
      .when('organization', {
        is: (organization) => organization && isDrpp(organization?.isdrpp),
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().nullable(),
      }),
    membershipNumber: Yup.string()
      .notRequired()
      .when('organization', {
        is: (organization) =>
          organization &&
          isNumAdhesion(organization?.numAdhesion, organization?.isdrpp),
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().nullable(),
      }),
    cin: Yup.string()
      .notRequired()
      .when('organization', {
        is: (organization) =>
          organization &&
          !isNumAdhesion(organization?.numAdhesion, organization?.isdrpp) &&
          !isDrpp(organization?.isdrpp),
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().nullable(),
      }),
  });
